"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactInsetBanner = _interopRequireDefault(require("@pcty/react-inset-banner"));
var _inputTextarea = require("@citrus/input-textarea");
var PctyQuestionBuilderEditHintsAndResponses = function PctyQuestionBuilderEditHintsAndResponses(_ref) {
  var hint = _ref.hint,
    onChangeFeedbackHint = _ref.onChangeFeedbackHint,
    correctFeedback = _ref.correctFeedback,
    onChangeFeedbackPositive = _ref.onChangeFeedbackPositive,
    incorrectFeedback = _ref.incorrectFeedback,
    onChangeFeedbackNegative = _ref.onChangeFeedbackNegative;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_reactInsetBanner.default, {
    id: "information-inset-banner-hint",
    type: "information"
  }, /*#__PURE__*/_react.default.createElement("p", null, hint || 'This is a preview of what your hint will look like if you enter one below.')))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_inputTextarea.Textarea, {
    id: "edit-feedback-hint",
    maxLength: 500,
    onChange: onChangeFeedbackHint,
    placeholder: "Enter a hint here",
    value: hint
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_reactInsetBanner.default, {
    id: "success-inset-banner-positive",
    type: "success"
  }, /*#__PURE__*/_react.default.createElement("p", null, correctFeedback || 'This is a preview of what your feedback will look like if you enter it below.')))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_inputTextarea.Textarea, {
    id: "edit-feedback-positive",
    maxLength: 500,
    onChange: onChangeFeedbackPositive,
    placeholder: "Enter feedback for a correct answer here",
    value: correctFeedback
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_reactInsetBanner.default, {
    id: "success-inset-banner-negative",
    type: "error"
  }, /*#__PURE__*/_react.default.createElement("p", null, incorrectFeedback || 'This is a preview of what your feedback will look like if you enter it below.')))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_inputTextarea.Textarea, {
    id: "edit-feedback-negative",
    maxLength: 500,
    onChange: onChangeFeedbackNegative,
    placeholder: "Enter feedback for an incorrect answer here",
    value: incorrectFeedback
  }))));
};
PctyQuestionBuilderEditHintsAndResponses.propTypes = {
  hint: _propTypes.default.string.isRequired,
  onChangeFeedbackHint: _propTypes.default.func.isRequired,
  correctFeedback: _propTypes.default.string.isRequired,
  onChangeFeedbackPositive: _propTypes.default.func.isRequired,
  incorrectFeedback: _propTypes.default.string.isRequired,
  onChangeFeedbackNegative: _propTypes.default.func.isRequired
};
var _default = exports.default = PctyQuestionBuilderEditHintsAndResponses;